<app-page-body>
  <!-- header -->
  <app-page-header
    [title]="'common.help'"
    [isForm]="true"
    [loading]="loading"
    (onBack)="onClose()"
    (onRefresh)="onReset()"
  >
  </app-page-header>

  <!-- content -->
  <div class="app-page-content">
    <!-- form -->
    <form [formGroup]="form" (ngSubmit)="onSubmit()" autocomplete="off">
      <div class="row">
        <div class="2xl:tw-w-1/2 tw-w-full">
          <fieldset class="tw-h-full">
            <legend>
              {{ "common.titleAndTextHelp" | translate }}
            </legend>

            <div class="row tw-flex tw-flex-col p-3 tw-sticky tw-top-[110px]">
              <!--* title -->
              <div class="tw-w-full">
                <form-field
                  [value]="model.menuHelpTitle"
                  [control]="form.get('title')"
                  label="common.title"
                  type="text"
                ></form-field>
              </div>

              <!--* textHelp  -->
              <div class="tw-w-full">
                <app-ngx-editor
                [control]="form.get('textHelp')"
                >   
              </app-ngx-editor>
              </div>
            </div>
          </fieldset>
        </div>

        <div class="2xl:tw-w-1/2 tw-w-full">
          <fieldset class="tw-h-full">
            <legend>
              {{ "common.files" | translate }}
            </legend>
            <!--* file-list -->
            <div class="tw-p-5 tw-w-full">
              <app-file-card-list
                [files]="files"
                [service]="currentService"
                [methodName]="apiMethodName"
                (deleteCard)="deleteCard($event)"
                (addCard)="addNewCard()"
              ></app-file-card-list>
            </div>
          </fieldset>
        </div>
      </div>

      <!-- *form btns-->
      <app-form-btns
        [loading]="loading"
        [form]="form"
        [isEdit]="formPageConfig.isEditMode"
        (onClose)="onClose()"
        (onSubmit)="onSubmit()"
      >
      </app-form-btns>
    </form>
  </div>
</app-page-body>
